import { AxiosResponse } from 'axios'
import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

export type TranscribeAudioType = true | false | null

export const updateTranscriptionPreference = async (transcribeAudio: TranscribeAudioType): Promise<AxiosResponse> => {
  const response = await axios.put(
    apiEndpoints.ME_PREFERENCES,
    {
      transcribe_audio: transcribeAudio
    })

  return response
}